/* What the device can do, as opposed to how big its screen is.

   ADR 0007 principle 2 splits these deliberately: capability decides
   affordances and navigation model, width decides arrangement. A tablet with a
   trackpad and a phone are different problems, and a width query conflates them.

   Read ONCE, at construction, and never re-evaluated — see the note on
   `isCoarsePointer`. Callers take the value as an argument rather than calling
   this themselves, which is what makes the behaviour it drives testable without
   a browser. */

/**
 * True on a touch-primary device.
 *
 * Deliberately a plain function with no caching and no change listener. What it
 * drives is which *markup* a row renders — the hover cluster or the ⋮ (ADR
 * 0020) — and re-deriving that mid-session would swap a row's controls under the
 * finger already on them. Consumers read it once at construction and hold the
 * answer. A phone does not become a desktop (ADR 0007 decision 7).
 *
 * `Router` no longer reads this: the history model is the same on every device
 * since ADR 0021, which is what removed the corrupt-back-stack hazard that first
 * motivated reading the capability once.
 */
export function isCoarsePointer(): boolean {
  return window.matchMedia('(pointer: coarse)').matches;
}
